import { PAGE_URLS } from "./pageUrls";

export const MODULE_PERMISSIONS = {
  //components, modules
  DashboardALL: "Dashboard.All",

  //   program template
  CREATE_PROGRAM_TEMPLATE: "ProgramTemplate.createprogramtemplate", //confirm on this data issue or something
  ADD_COMPATIBLE_TEMPLATES: "ProgramTemplate.AddCompatibleTemplates",
  EDIT_COMPATIBLE_TEMPLATES: "ProgramTemplate.EditCompatibleTemplates",
  VIEW_COMPATIBLE_TEMPLATES: "ProgramTemplate.ViewCompatibleTemplates",
  DELETE_COMPATIBLE_TEMPLATES: "ProgramTemplate.DeleteCompatibleTemplates",
  ADD_ACTIVITIES_AND_DELIVERABLES:
    "ProgramTemplate.AddActivitiesAndDeliverables",
  VIEW_ACTIVITIES_AND_DELIVERABLES:
    "ProgramTemplate.ViewActivitiesAndDeliverables",
  DELETE_ACTIVITIES_AND_DELIVERABLES:
    "ProgramTemplate.DeleteActivitiesAndDeliverables",
  EDIT_ACTIVITIES_AND_DELIVERABLES:
    "ProgramTemplate.EditActivitiesAndDeliverables",
  EDIT_PROFILE: "ProgramTemplate.EditProfile",
  ADD_PROFILE: "ProgramTemplate.AddProfile",
  VIEW_PROFILE: "ProgramTemplate.ViewProfile",
  // page_level
  PROGRAM_TEMPLATE_CREATE: "ProgramTemplate.Create",
  PROGRAM_TEMPLATE_VIEW: "ProgramTemplate.View",
  PROGRAM_TEMPLATE_EDIT: "ProgramTemplate.Edit",
  PROGRAM_TEMPLATE_DELETE: "ProgramTemplate.Delete", // N/A

  //   program
  DELETE_PROGRAM_DETAILS: "Program.DeleteProgramDetails", // N/A
  ADD_KEY_PROGRAM_DETAIL: "Program.AddKeyProgramDetail", // N/A
  EDIT_KEY_PROGRAM_DETAIL: "Program.EditKeyProgramDetail",
  VIEW_KEY_PROGRAM_DETAIL: "Program.ViewKeyProgramDetail",
  ADD_PROGRAM_DETAILS: "Program.AddProgramDetails",
  DELETE_OTHER_DETAILS: "Program.DeleteOtherDetails", // N/A
  EDIT_INVOICE_GENERATION: "Program.EditInvoiceGeneration", // N/A
  EDIT_PROGRAM_DETAILS: "Program.EditProgramDetails",
  VIEW_PROGRAM_DETAILS: "Program.ViewProgramDetails",
  ADD_OTHER_DETAILS: "Program.AddOtherDetails",
  EDIT_OTHER_DETAILS: "Program.EditOtherDetails",
  DELETE_PROGRAM_STATUS: "Program.DeleteProgramStatus", // N/A
  VIEW_OTHER_DETAILS: "Program.ViewOtherDetails",
  EDIT_PROGRAM_STATUS: "Program.EditProgramStatus",
  VIEW_INVOICE_GENERATION: "Program.ViewInvoiceGeneration", // N/A
  VIEW_PROGRAM_STATUS: "Program.ViewProgramStatus",
  ADD_SALES_CREDIT: "Program.AddSalesCredit",
  EDIT_SALES_CREDIT: "Program.EditSalesCredit",
  VIEW_SALES_CREDIT: "Program.ViewSalesCredit",
  ADD_PARTICIPANT_INFORMATION: "Program.AddParticipantInformation",
  EDIT_PARTICIPANT_INFORMATION: "Program.EditParticipantInformation",
  ADD_INVOICE_HISTORY: "Program.AddInvoiceHistory", // N/A
  VIEW_PARTICIPANT_INFORMATION: "Program.ViewParticipantInformation",
  ADD_ADDRESS_DETAILS: "Program.AddAddresDetails",
  EDIT_INVOICE_HISTORY: "Program.EditInvoiceHistory", // N/A
  EDIT_ADDRESS_DETAILS: "Program.EditAddresDetails",
  VIEW_ADDRESS_DETAILS: "Program.ViewAddresDetails",
  ADD_OUTREACH: "Program.AddOutreach",
  EDIT_OUTREACH: "Program.EditOutreach",
  VIEW_OUTREACH: "Program.ViewOutreach",
  ADD_SPONSORING_EMPLOYER: "Program.AddSponsoringEmployer",
  EDIT_SPONSORING_EMPLOYER: "Program.EditSponsoringEmployer",
  ADD_CAREER_GOALS: "Program.AddCareerGoals", // N/A (Only Available for Edit Program)
  VIEW_SPONSORING_EMPLOYER: "Program.ViewSponsoringEmployer",
  ADD_COACH_ASSIGNMENT: "Program.AddCoachAssignment",
  EDIT_COACH_ASSIGNMENT: "Program.EditCoachAssignment",
  VIEW_COACH_ASSIGNMENT: "Program.ViewCoachAssignment",
  FEES_AND_EXPENSE: "Program.feesandexpense", // N/A
  DELETE_COACH_ASSIGNMENT: "Program.DeleteCoachAssignment",
  DELETE_PARTICIPANT_INFORMATION: "Program.DeleteParticipantInformation", // N/A
  EDIT_CAREER_GOALS: "Program.EditCareerGoals",
  VIEW_CAREER_GOALS: "Program.ViewCareerGoals",
  PROGRAM_FEE: "Program.programfee", // N/A
  ADD_PARTICIPANT_ACTIVITY_TIMELINE: "Program.AddParticipantActivitityTimeline",
  DELETE_ADDRESS_DETAILS: "Program.DeleteAddresDetails", // N/A
  EDIT_PARTICIPANT_ACTIVITY_TIMELINE:
    "Program.EditParticipantActivitityTimeline",
  VIEW_PARTICIPANT_ACTIVITY_TIMELINE:
    "Program.ViewParticipantActivitityTimeline",
  DELETE_OUTREACH: "Program.DeleteOutreach", //N/A
  ADD_PROGRAM_FEE: "Program.AddProgramFee",
  EDIT_PROGRAM_FEE: "Program.EditProgramFee",
  VIEW_PROGRAM_FEE: "Program.ViewProgramFee",
  ADD_TAX_DETAILS: "Program.AddTaxDetails",
  EDIT_TAX_DETAILS: "Program.EditTaxDetails",
  DELETE_TAX_DETAILS: "Program.DeleteTaxDetails",
  VIEW_TAX_DETAILS: "Program.ViewTaxDetails",
  EDIT_INVOICE_REVERSAL: "Program.EditInvoiceReversal",
  ADD_FEE_AND_EXPENSES: "Program.AddFeeAndExpenses",
  DELETE_SPONSORING_EMPLOYER: "Program.DeleteSponsoringEmployer", // N/A
  EDIT_FEE_AND_EXPENSES: "Program.EditFeeAndExpenses",
  VIEW_FEE_AND_EXPENSES: "Program.ViewFeeAndExpenses",
  DELETE_FEE_AND_EXPENSES: "Program.DeleteFeeAndExpenses",
  DELETE_CAREER_GOALS: "Program.DeleteCareerGoals", // N/A
  DELETE_PARTICIPANT_ACTIVITY_TIMELINE:
    "Program.DeleteParticipantActivitityTimeline", // N/A
  ADD_DOCUMENTS: "Program.AddDocuments",
  EDIT_DOCUMENTS: "Program.EditDocuments",
  DELETE_DOCUMENTS: "Program.DeleteDocuments",
  VIEW_DOCUMENTS: "Program.ViewDocuments",

  //   project
  PROJECT_ADD_KEY_PROJECT_DETAILS: "Project.AddKeyProjectDetails",
  PROJECT_EDIT_KEY_PROJECT_DETAILS: "Project.EditKeyProjectDetails",
  PROJECT_VIEW_KEY_PROJECT_DETAILS: "Project.ViewKeyProjectDetails",
  PROJECT_VIEW_OFFICE_AND_CONTACT_DETAILS:
    "Project.ViewOfficeAndContactDetails",
  PROJECT_ADD_OFFICE_AND_CONTACT_DETAILS: "Project.AddOfficeAndContactDetails",
  PROJECT_EDIT_OFFICE_AND_CONTACT_DETAILS:
    "Project.EditOfficeAndContactDetails",
  PROJECT_ADD_PROJECT_STATUS: "Project.AddProjectStatus",
  PROJECT_VIEW_PROJECT_STATUS: "Project.ViewProjectStatus",
  PROJECT_EDIT_PROJECT_STATUS: "Project.EditProjectStatus",
  PROJECT_VIEW_SALES_CREDIT: "Project.ViewSalesCredit",
  PROJECT_ADD_SALES_CREDIT: "Project.AddSalesCredit",
  PROJECT_EDIT_SALES_CREDIT: "Project.EditSalesCredit",
  PROJECT_VIEW_FACILITATOR: "Project.ViewFacilitator",
  PROJECT_ADD_FACILITATOR: "Project.AddFacilitator",
  PROJECT_EDIT_FACILITATOR: "Project.EditFacilitator",
  PROJECT_VIEW_ACTIVITIES_AND_DELIVERABLES:
    "Project.ViewActivitiesAndDeliverables",
  PROJECT_ADD_ACTIVITIES_AND_DELIVERABLES:
    "Project.AddActivitiesAndDeliverables",
  PROJECT_EDIT_ACTIVITIES_AND_DELIVERABLES:
    "Project.EditActivitiesAndDeliverables",
  PROJECT_VIEW_ACTIVITY_TIMELINE: "Project.ViewActivityTimeline",
  PROJECT_ADD_ACTIVITY_TIMELINE: "Project.AddActivityTimeline",
  PROJECT_EDIT_ACTIVITY_TIMELINE: "Project.EditActivityTimeline",
  PROJECT_DELETE_ACTIVITY_TIMELINE: "Project.DeleteActivityTimeline",
  PROJECT_ADD_PROJECT_FEE: "Project.AddProjectFee",
  PROJECT_EDIT_PROJECT_FEE: "Project.EditProjectFee",
  PROJECT_VIEW_PROJECT_FEE: "Project.ViewProjectFee",
  PROJECT_DELETE_PROJECT_FEE: "Project.DeletProjectFee",
  PROJECT_VIEW_CHILD_PROGRAMS: "Project.ViewChildPrograms",
  PROJECT_ADD_CHILD_PROGRAMS: "Project.AddChildPrograms",
  PROJECT_EDIT_CHILD_PROGRAMS: "Project.EditChildPrograms",
  PROJECT_ADD_FEES_AND_EXPENSES: "Project.AddFeesAndExpenses",
  PROJECT_EDIT_FEES_AND_EXPENSES: "Project.EditFeesAndExpenses",
  PROJECT_VIEW_FEES_AND_EXPENSES: "Project.ViewFeesAndExpenses",
  PROJECT_DELETE_FEES_AND_EXPENSES: "Project.DeleteFeesAndExpenses",
  PROJECT_ADD_GENERATE_INVOICE: "Project.AddGenerateInvoice",
  PROJECT_EDIT_GENERATE_INVOICE: "Project.EditGenerateInvoice",
  PROJECT_VIEW_GENERATE_INVOICE: "Project.ViewGenerateInvoice",
  PROJECT_DELETE_GENERATE_INVOICE: "Project.DeleteGenerateInvoice",
  PROJECT_VIEW_INVOICE_HISTORY: "Project.ViewInvoiceHistory",
  PROJECT_VIEW_INVOICE: "Project.ViewInvoice",
  PROJECT_ADD_TAX_DETAILS: "Project.AddTaxDetails",
  PROJECT_EDIT_TAX_DETAILS: "Project.EditTaxDetails",
  PROJECT_VIEW_TAX_DETAILS: "Project.ViewTaxDetails",
  PROJECT_DELETE_TAX_DETAILS: "Project.DeleteTaxDetails",
  PROJECT_DELETE_ACTIVITIES_AND_DELIVERABLES:
    "Project.DeleteActivitiesAndDeliverables",

  //Page level project
  PROJECT_CREATE: "Project.Create",
  PROJECT_VIEW: "Project.View",
  PROJECT_EDIT: "Project.Edit",
  PROJECT_DELETE: "Project.Delete", // N/A

  //Page level
  PROGRAM_CREATE: "Program.Create",
  PROGRAM_VIEW: "Program.View",
  PROGRAM_EDIT: "Program.Edit",
  PROGRAM_DELETE: "Program.Delete", // N/A

  //program billing and invoice
  PROGRAM_VIEW_INVOICE_HISTORY: "Program.ViewInvoiceHistory",
  PROGRAM_ADD_INVOICE_GENERATION: "Program.AddInvoiceGeneration",
  PROGRAM_INVOICE_REVERSAL: "Program.AddInvoiceReversal",
  PROGRAM_VIEW_INVOICE: "Program.ViewInvoice",

  // bulk process
  BULK_PROCESS_STATS: "Program.BulkProcessStats",
  BULK_INSERT: "Program.BulkInsert",
  BULK_TRANSFER: "Program.BulkTransfer",
  BULK_EDIT: "Program.BulkEdit",
  BULK_CREATE: "Program.BulkCreate",

  // Generic Account
  GENERIC_ACCOUNT_CREATE: "GenericAccount.Create",
  GENERIC_ACCOUNT_EDIT: "GenericAccount.Edit",
  GENERIC_ACCOUNT_VIEW: "GenericAccount.View",
  GENERIC_ACCOUNT_DELETE: "GenericAccount.Delete",

  GENERIC_ACCOUNT_ADD_EVENTS: "GenericAccount.AddEvents",
  GENERIC_ACCOUNT_EDIT_EVENTS: "GenericAccount.EditEvents",
  GENERIC_ACCOUNT_DELETE_EVENTS: "GenericAccount.DeleteEvents",
  GENERIC_ACCOUNT_VIEW_EVENTS: "GenericAccount.ViewEvents",
  GENERIC_ACCOUNT_EDIT_CONFIGURATION: "GenericAccount.EditConfigurataion",
  GENERIC_ACCOUNT_ADD_CONFIGURATION: "GenericAccount.AddConfigurataion",
  GENERIC_ACCOUNT_VIEW_CONFIGURATION: "GenericAccount.ViewConfigurataion",
  GENERIC_ACCOUNT_ADD_PARTICIPANT_INFORMATION:
    "GenericAccount.AddParticipantInformation",
  GENERIC_ACCOUNT_EDIT_PARTICIPANT_INFORMATION:
    "GenericAccount.EditParticipantInformation",
  GENERIC_ACCOUNT_VIEW_PARTICIPANT_INFORMATION:
    "GenericAccount.ViewParticipantInformation",
  GENERIC_ACCOUNT_DELETE_PARTICIPANT_INFORMATION:
    "GenericAccount.DeleteParticipantInformation",
  GENERIC_ACCOUNT_ADD_BASIC_DETAILS: "GenericAccount.AddBasicDetails",
  GENERIC_ACCOUNT_EDIT_BASIC_DETAILS: "GenericAccount.EditBasicDetails",
  GENERIC_ACCOUNT_VIEW_BASIC_DETAILS: "GenericAccount.ViewBasicDetails",
  GENERIC_ACCOUNT_ADD_PLATFORM_DETAILS: "GenericAccount.AddPlatformDetails",
  GENERIC_ACCOUNT_EDIT_PLATFORM_DETAILS: "GenericAccount.EditPlatformDetails",
  GENERIC_ACCOUNT_VIEW_PLATFORM_DETAILS: "GenericAccount.ViewPlatformDetails",
  GENERIC_ACCOUNT_EDIT_CONTACT_PREFERENCES:
    "GenericAccount.EditParticipantContactPreferences",
  GENERIC_ACCOUNT_ADD_CONTACT_PREFERENCES:
    "GenericAccount.AddParticipantContactPreferences",
  GENERIC_ACCOUNT_VIEW_CONTACT_PREFERENCES:
    "GenericAccount.ViewParticipantContactPreferences",
  GENERIC_ACCOUNT_DELETE_PLATFORM_DETAILS:
    "GenericAccount.DeletePlatformDetails",
  GENERIC_ACCOUNT_ADD_PROGRAM_INFORMATION:
    "GenericAccount.AddProgramInformation",
  GENERIC_ACCOUNT_EDIT_PROGRAM_INFORMATION:
    "GenericAccount.EditProgramInformation",
  GENERIC_ACCOUNT_VIEW_PROGRAM_INFORMATION:
    "GenericAccount.ViewProgramInformation",
  GENERIC_ACCOUNT_DELETE_PROGRAM_INFORMATION:
    "GenericAccount.DeleteProgramInformation",
  GENERIC_ACCOUNT_ADD_PARTICIPANT_ACTIVITY_TIMELINE:
    "GenericAccount.AddParticipantActivityTimeline",
  GENERIC_ACCOUNT_EDIT_PARTICIPANT_ACTIVITY_TIMELINE:
    "GenericAccount.EditParticipantActivityTimeline",
  GENERIC_ACCOUNT_DELETE_PARTICIPANT_ACTIVITY_TIMELINE:
    "GenericAccount.DeleteParticipantActivityTimeline",
  GENERIC_ACCOUNT_VIEW_PARTICIPANT_ACTIVITY_TIMELINE:
    "GenericAccount.ViewParticipantActivityTimeline",

  SEARCH_AND_VIEW_CANDIDATES: "Candidate.searchandviewcandidates",
  SEND_CANDIDATE_A_NOTE: "Candidate.sendcandidateanote",
  VIEW_CANDIDATE_ACTIVITY_LOG: "Candidate.viewcandidateactivitylog",
  VIEW_CANDIDATE_DOCUMENTS: "Candidate.viewcandidatedocuments",
  UPLOAD_DOCUMENT_ON_BEHALF_OF_CANDIDATE:
    "Candidate.uploaddocumentonbehalfofcandidate",
  VIEW_CLIENT_PROGRAM_SETUP: "Clients.viewclientprogramsetup",
  EDIT_CLIENT_PROGRAM_SETUP: "Clients.editclientprogramsetup",
  CREATE_CLIENT_PROGRAM_SETUP: "Clients.createclientprogramsetup",
  AUDIT_CANDIDATE: "Audit Page.candidate",
  AUDIT_USERS: "Audit Page.users",
  AUDIT_GENERIC_ACCOUNTS: "Audit Page.genericaccounts",
  AUDIT_CLIENT: "Audit Page.client",
  AUDIT_COACH: "Audit Page.coach(2nd Prio)",
  AUDIT_SERVICE_OFFICE: "Audit Page.serviceoffice(2nd Prio)",
  CLIENT_SPECIFIC_CONTENT: "Client specific content.clientspecificcontent",

  // client permissions
  VIEW_CLIENT: "Client.View",
  EDIT_CLIENT: "Client.Edit",
  CREATE_CLIENT: "Client.Create",
  ADD_CLIENT_PROFILE_DETAILS: "Client.AddProfileDetails",
  EDIT_CLIENT_PROFILE_DETAILS: "Client.EditProfileDetails",
  VIEW_CLIENT_PROFILE_DETAILS: "Client.ViewProfileDetails",
  ADD_CLIENT_MAILING_ADDRESS_DETAILS: "Client.AddMailingAddressDetails",
  EDIT_CLIENT_MAILING_ADDRESS_DETAILS: "Client.EditMailingAddressDetails",
  VIEW_CLIENT_MAILING_ADDRESS_DETAILS: "Client.ViewMailingAddressDetails",
  ADD_CLIENT_CONTACTS: "Client.AddContacts",
  EDIT_CLIENT_CONTACTS: "Client.EditContacts",
  VIEW_CLIENT_CONTACTS: "Client.ViewContacts",
  DELETE_CLIENT_CONTACTS: "Client.DeleteContacts",
  ADD_CLIENT_PARENT_CONTACTS: "Client.AddParentContacts",
  EDIT_CLIENT_PARENT_CONTACTS: "Client.EditParentContacts",
  VIEW_CLIENT_PARENT_CONTACTS: "Client.ViewParentContacts",
  DELETE_CLIENT_PARENT_CONTACTS: "Client.DeleteParentContacts",
  ADD_CLIENT_SPECIFIC_CONTENT: "Client.AddClientSpecificContent",
  EDIT_CLIENT_SPECIFIC_CONTENT: "Client.EditClientSpecificContent",
  VIEW_CLIENT_SPECIFIC_CONTENT: "Client.ViewClientSpecificContent",
  DELETE_CLIENT_SPECIFIC_CONTENT: "Client.DeleteClientSpecificContent",
  ADD_CLIENT_SPECIFIC_ACTIVITIES: "Client.AddClientSpecificActivities",
  EDIT_CLIENT_SPECIFIC_ACTIVITIES: "Client.EditClientSpecificActivities",
  VIEW_CLIENT_SPECIFIC_ACTIVITIES: "Client.ViewClientSpecificActivities",
  DELETE_CLIENT_SPECIFIC_ACTIVITIES: "Client.DeleteClientSpecificActivities",
  ADD_CLIENT_DOCUMENTS: "Client.AddDocuments",
  EDIT_CLIENT_DOCUMENTS: "Client.EditDocuments",
  VIEW_CLIENT_DOCUMENTS: "Client.ViewDocuments",
  DELETE_CLIENT_DOCUMENTS: "Client.DeleteDocuments",
  ADD_CLIENT_BILLING_CONFIG: "Client.AddBillingConfig",
  EDIT_CLIENT_BILLING_CONFIG: "Client.EditBillingConfig",
  VIEW_CLIENT_BILLING_CONFIG: "Client.ViewBillingConfig",
  DELETE_CLIENT_BILLING_CONFIG: "Client.DeleteBillingConfig",
  ADD_CLIENT_PURCHASE_ORDER: "Client.AddPurchaseOrder",
  EDIT_CLIENT_PURCHASE_ORDER: "Client.EditPurchaseOrder",
  DELETE_CLIENT_PURCHASE_ORDER: "Client.DeletePurchaseOrder",
  VIEW_CLIENT_PURCHASE_ORDER: "Client.ViewPurchaseOrder",

  //permissions and messages
  VIEW_USERS: "User.UserView",
  EDIT_USERS: "User.UserEdit",
  CREATE_USERS: "User.UserAdd",
  DELETE_USERS: "User.UserDelete",

  //system messages
  CREATE_SYSTEM_MESSAGES: "MDM.SystemMessageAdd",
  VIEW_SYSTEM_MESSAGES: "MDM.SystemMessageView",
  EDIT_SYSTEM_MESSAGES: "MDM.SystemMessageEdit",
  DELETE_SYSTEM_MESSAGES: "MDM.SystemMessageDelete",

  //MDM activity permissions
  ADD_MDM_ACTIVITY: "MDM.ActivityAdd",
  EDIT_MDM_ACTIVITY: "MDM.ActivityEdit",
  VIEW_MDM_ACTIVITY: "MDM.ActivityView",
  DELETE_MDM_ACTIVITY: "MDM.ActivityDelete",

  //MDM office permissions
  ADD_MDM_OFFICE: "MDM.OfficeAdd",
  EDIT_MDM_OFFICE: "MDM.OfficeEdit",
  VIEW_MDM_OFFICE: "MDM.OfficeView",
  DELETE_MDM_OFFICE: "MDM.OfficeDelete",

  //Page level Coach Portal
  COACH_PORTAL_VIEW: "CoachPortal.View",
  COACH_PORTAL_EDIT: "CoachPortal.Edit",

  // Coach Portal
  COACH_PORTAL_DELETE_SPONSORING_EMPLOYER:
    "CoachPortal.DeleteSponsoringEmployer",
  COACH_PORTAL_EDIT_PARTICIPANT_INFORMATION:
    "CoachPortal.EditParticipantInformation",
  COACH_PORTAL_VIEW_KEY_PROGRAM_DETAIL: "CoachPortal.ViewKeyProgramDetail",
  COACH_PORTAL_EDIT_SPONSORING_EMPLOYER: "CoachPortal.EditSponsoringEmployer",
  COACH_PORTAL_EDIT_KEY_PROGRAM_DETAIL: "CoachPortal.EditKeyProgramDetail",
  COACH_PORTAL_ADD_KEY_PROGRAM_DETAIL: "CoachPortal.AddKeyProgramDetail",
  COACH_PORTAL_VIEW_OTHER_DETAILS: "CoachPortal.ViewOtherDetails",
  COACH_PORTAL_VIEW_CAREER_GOALS: "CoachPortal.ViewCareerGoals",
  COACH_PORTAL_VIEW_COACH_ASSIGNMENT: "CoachPortal.ViewCoachAssignment",
  COACH_PORTAL_DELETE_PROGRAM_STATUS: "CoachPortal.DeleteProgramStatus",
  COACH_PORTAL_ADD_PARTICIPANT_INFORMATION:
    "CoachPortal.AddParticipantInformation",
  COACH_PORTAL_VIEW_PROGRAM_STATUS: "CoachPortal.ViewProgramStatus",
  COACH_PORTAL_DELETE_COACH_ASSIGNMENT: "CoachPortal.DeleteCoachAssignment",
  COACH_PORTAL_EDIT_ADDRESS_DETAILS: "CoachPortal.EditAddresDetails",

  COACH_PORTAL_EDIT_PARTICIPANT_ACTIVITY_TIMELINE:
    "CoachPortal.EditParticipantActivitityTimeline",
  COACH_PORTAL_DELETE_OUTREACH: "CoachPortal.DeleteOutreach",
  COACH_PORTAL_ADD_CAREER_GOALS: "CoachPortal.AddCareerGoals",
  COACH_PORTAL_VIEW_ADDRESS_DETAILS: "CoachPortal.ViewAddresDetails",
  COACH_PORTAL_ADD_ADDRESS_DETAILS: "CoachPortal.AddAddresDetails",
  COACH_PORTAL_ADD_SPONSORING_EMPLOYER: "CoachPortal.AddSponsoringEmployer",
  COACH_PORTAL_EDIT_OTHER_DETAILS: "CoachPortal.EditOtherDetails",
  COACH_PORTAL_DELETE_PARTICIPANT_ACTIVITY_TIMELINE:
    "CoachPortal.DeleteParticipantActivitityTimeline",
  COACH_PORTAL_DELETE_ADDRESS_DETAILS: "CoachPortal.DeleteAddresDetails",
  COACH_PORTAL_ADD_OUTREACH: "CoachPortal.AddOutreach",
  COACH_PORTAL_EDIT_PROGRAM_DETAILS: "CoachPortal.EditProgramDetails",
  COACH_PORTAL_DELETE_PARTICIPANT_INFORMATION:
    "CoachPortal.DeleteParticipantInformation",
  COACH_PORTAL_VIEW_PARTICIPANT_ACTIVITY_TIMELINE:
    "CoachPortal.ViewParticipantActivitityTimeline",
  COACH_PORTAL_VIEW_PARTICIPANT_INFORMATION:
    "CoachPortal.ViewParticipantInformation",
  COACH_PORTAL_EDIT_PROGRAM_STATUS: "CoachPortal.EditProgramStatus",
  COACH_PORTAL_VIEW_OUTREACH: "CoachPortal.ViewOutreach",
  COACH_PORTAL_ADD_PARTICIPANT_ACTIVITY_TIMELINE:
    "CoachPortal.AddParticipantActivitityTimeline",
  COACH_PORTAL_EDIT_CAREER_GOALS: "CoachPortal.EditCareerGoals",
  COACH_PORTAL_EDIT_OUTREACH: "CoachPortal.EditOutreach",
  COACH_PORTAL_DELETE_CAREER_GOALS: "CoachPortal.DeleteCareerGoals",
  COACH_PORTAL_EDIT_COACH_ASSIGNMENT: "CoachPortal.EditCoachAssignment",
  COACH_PORTAL_DELETE_OTHER_DETAILS: "CoachPortal.DeleteOtherDetails",
  COACH_PORTAL_ADD_PROGRAM_DETAILS: "CoachPortal.AddProgramDetails",
  COACH_PORTAL_VIEW_SPONSORING_EMPLOYER: "CoachPortal.ViewSponsoringEmployer",
  COACH_PORTAL_VIEW_PROGRAM_DETAILS: "CoachPortal.ViewProgramDetails",
  COACH_PORTAL_ADD_OTHER_DETAILS: "CoachPortal.AddOtherDetails",
  COACH_PORTAL_ADD_COACH_ASSIGNMENT: "CoachPortal.AddCoachAssignment",
  COACH_PORTAL_ADD_DOCUMENTS: "CoachPortal.AddDocuments",
  COACH_PORTAL_EDIT_DOCUMENTS: "CoachPortal.EditDocuments",
  COACH_PORTAL_DELETE_DOCUMENTS: "CoachPortal.DeleteDocuments",
  COACH_PORTAL_VIEW_DOCUMENTS: "CoachPortal.ViewDocuments",

  //Page level Report
  REPORT_VIEW: "Report.View",

  // Report
  REPORT_BILLING: "Report.Billing",
  REPORT_OUTREACH: "Report.Outreach",
  REPORT_COACH: "Report.Coach",

  //Client Portal Setup
  CLIENT_PORTAL_SETUP_VIEW: "ClientPortalSetup.View",
  CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS: "ClientPortalSetup.ClientAccounts",
  CLIENT_PORTAL_SETUP_REPORTS: "ClientPortalSetup.Reports",
  CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR:
    "ClientPortalSetup.ProgrammeDescriptor",
  CLIENT_PORTAL_SETUP_REFERRALS: "ClientPortalSetup.Referrals",
  CLIENT_PORTAL_SETUP_CLIENT_USERS: "ClientPortalSetup.ClientUsers",
  CLIENT_PORTAL_SETUP_ACC_TEAM: "ClientPortalSetup.AccTeam",
  CLIENT_PORTAL_SETUP_ADMIN_MESSAGES: "ClientPortalSetup.AdminMessages",
  CLIENT_PORTAL_SETUP_MEETING_REQUESTS: "ClientPortalSetup.MeetingRequests",

  //NIS
  NIS_VIEW: "NIS.View",
  NIS_EDIT: "NIS.Edit",
  NIS_CREATE: "NIS.Create",
  NIS_DELETE: "NIS.Delete",
};

export const PAGE_PERMISSIONS_MAPPINGS = {
  [PAGE_URLS.DASHBOARD]: MODULE_PERMISSIONS.DashboardALL,

  [PAGE_URLS.SEARCH_PROGRAM]: MODULE_PERMISSIONS.PROGRAM_VIEW, //view is considered for search
  [PAGE_URLS.CREATE_PROGRAM]: MODULE_PERMISSIONS.PROGRAM_CREATE,
  [`${PAGE_URLS.EDIT_PROGRAM}/:id`]: MODULE_PERMISSIONS.PROGRAM_EDIT,
  [`${PAGE_URLS.VIEW_PROGRAM}/:id`]: MODULE_PERMISSIONS.PROGRAM_VIEW,

  [PAGE_URLS.PROGRAM_TEMPLATE]: MODULE_PERMISSIONS.PROGRAM_TEMPLATE_VIEW, //view is considered for search
  [PAGE_URLS.CREATE_PROGRAM_TEMPLATE]:
    MODULE_PERMISSIONS.PROGRAM_TEMPLATE_CREATE,
  [`${PAGE_URLS.EDIT_PROGRAM_TEMPLATE}/:id`]:
    MODULE_PERMISSIONS.PROGRAM_TEMPLATE_EDIT,
  [`${PAGE_URLS.VIEW_PROGRAM_TEMPLATE}/:id`]:
    MODULE_PERMISSIONS.PROGRAM_TEMPLATE_VIEW,

  [PAGE_URLS.SEARCH_CLIENT]: MODULE_PERMISSIONS.VIEW_CLIENT,
  [PAGE_URLS.CREATE_CLIENT]: MODULE_PERMISSIONS.CREATE_CLIENT,
  [PAGE_URLS.EDIT_CLIENT]: MODULE_PERMISSIONS.EDIT_CLIENT,
  [`${PAGE_URLS.VIEW_CLIENT}/:id`]: MODULE_PERMISSIONS.VIEW_CLIENT,

  [PAGE_URLS.CREATE_NIP3_CANDIDATE]: "",

  [PAGE_URLS.GENERIC_ACCOUNTS_SEARCH]: MODULE_PERMISSIONS.GENERIC_ACCOUNT_VIEW,
  [PAGE_URLS.CREATE_GENERIC_ACCOUNTS]:
    MODULE_PERMISSIONS.GENERIC_ACCOUNT_CREATE,
  [PAGE_URLS.EDIT_GENERIC_ACCOUNTS]: MODULE_PERMISSIONS.GENERIC_ACCOUNT_EDIT,
  [PAGE_URLS.VIEW_GENERIC_ACCOUNT]: MODULE_PERMISSIONS.GENERIC_ACCOUNT_VIEW,

  [PAGE_URLS.VIEW_PARTICIPANT]: "",
  [PAGE_URLS.EDIT_PARTICIPANT]: "",

  [PAGE_URLS.MDM_ACTIVITY]: MODULE_PERMISSIONS.VIEW_MDM_ACTIVITY,
  [PAGE_URLS.MDM_OFFICE]: MODULE_PERMISSIONS.VIEW_MDM_OFFICE,
  [PAGE_URLS.REPORTS]: MODULE_PERMISSIONS.REPORT_VIEW,

  [PAGE_URLS.CREATE_BULK_ACTIVITY]: MODULE_PERMISSIONS.BULK_INSERT,
  [PAGE_URLS.BULK_CREATE_PROGRAM]: MODULE_PERMISSIONS.BULK_CREATE,
  [PAGE_URLS.BULK_EDIT_PROGRAM]: MODULE_PERMISSIONS.BULK_EDIT,
  [PAGE_URLS.CREATE_BULK_TRANSFER]: MODULE_PERMISSIONS.BULK_TRANSFER,

  [PAGE_URLS.MANAGE_BULK_PROCESS]: MODULE_PERMISSIONS.BULK_PROCESS_STATS,
  [PAGE_URLS.BULK_CREATE_PROGRAM_DETAILS]:
    MODULE_PERMISSIONS.BULK_PROCESS_STATS,
  [PAGE_URLS.BULK_EDIT_PROGRAM_DETAILS]: MODULE_PERMISSIONS.BULK_PROCESS_STATS,
  [PAGE_URLS.BULK_INSERT_ACTIVITY_DETAILS]: MODULE_PERMISSIONS.BULK_INSERT,
  [PAGE_URLS.BULK_TRANSFER_PARTICIPANTS_DETAILS]:
    MODULE_PERMISSIONS.BULK_TRANSFER,

  [PAGE_URLS.COACH_PORTAL_DASHBOARD]: MODULE_PERMISSIONS.COACH_PORTAL_VIEW,
  [PAGE_URLS.COACH_PORTAL_SEARCH_PARTICIPANTS]:
    MODULE_PERMISSIONS.COACH_PORTAL_VIEW,
  [`${PAGE_URLS.COACH_PORTAL_VIEW_PARTICIPANT}/:id`]:
    MODULE_PERMISSIONS.COACH_PORTAL_VIEW,
  [`${PAGE_URLS.COACH_PORTAL_EDIT_PARTICIPANT}/:id`]:
    MODULE_PERMISSIONS.COACH_PORTAL_EDIT,

  [PAGE_URLS.SEARCH_USERS]: MODULE_PERMISSIONS.VIEW_USERS,
  [PAGE_URLS.SYSTEM_MESSAGES]: MODULE_PERMISSIONS.VIEW_SYSTEM_MESSAGES,

  //project
  [PAGE_URLS.SEARCH_PROJECT]: MODULE_PERMISSIONS.PROJECT_VIEW, //view is considered for search
  [PAGE_URLS.CREATE_PROJECT]: MODULE_PERMISSIONS.PROJECT_CREATE,
  [`${PAGE_URLS.EDIT_PROJECT}/:id`]: MODULE_PERMISSIONS.PROJECT_EDIT,
  [`${PAGE_URLS.VIEW_PROJECT}/:id`]: MODULE_PERMISSIONS.PROJECT_VIEW,

  // Client Portal Setup
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACCOUNTS]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_ACCOUNT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_ACCOUNT_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_ACCOUNT_CREATE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_ACCOUNT_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_SUB_ACCOUNT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_SUB_ACCOUNT_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_SUB_ACCOUNT_CREATE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACCOUNTS_CLIENT_SUB_ACCOUNT_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_ACCOUNTS,

  [PAGE_URLS.CLIENT_PORTAL_SETUP_REPORTS]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REPORTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REPORTS_CLIENT_SPECIFIC_REPORT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REPORTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REPORTS_CLIENT_SPECIFIC_REPORT_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REPORTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REPORTS_CLIENT_SPECIFIC_REPORT_CREATE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REPORTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REPORTS_CLIENT_SPECIFIC_REPORT_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REPORTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REPORTS_THOUGHT_LEADERSHIP_RESOURCES]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REPORTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REPORTS_THOUGHT_LEADERSHIP_RESOURCES_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REPORTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REPORTS_THOUGHT_LEADERSHIP_RESOURCES_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REPORTS,

  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,

  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_CREATE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_ADD_CUSTOM_RESOURCE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_CLIENT_ACC_PD_FOLDER_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD_CREATE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR_MANAGE_ACC_PD_RECYCLE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_PROGRAMME_DESCRIPTOR,

  [PAGE_URLS.CLIENT_PORTAL_SETUP_REFERRALS]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REFERRALS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REFERRALS_ASSIGN_REFERRAL_REQ]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REFERRALS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REFERRALS_ASSIGN_REFERRAL_REQ_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REFERRALS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REFERRALS_ASSIGN_REFERRAL_REQ_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REFERRALS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REFERRALS_MANAGE_REFERRAL_REQ]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REFERRALS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REFERRALS_MANAGE_REFERRAL_REQ_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REFERRALS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_REFERRALS_MANAGE_REFERRAL_REQ_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_REFERRALS,

  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACC_TEAM]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_ACC_TEAM,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACC_TEAM_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_ACC_TEAM,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACC_TEAM_CREATE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_ACC_TEAM,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ACC_TEAM_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_ACC_TEAM,

  [PAGE_URLS.CLIENT_PORTAL_SETUP_MEETING_REQUESTS]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_MEETING_REQUESTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_MEETING_REQUESTS_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_MEETING_REQUESTS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_MEETING_REQUESTS_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_MEETING_REQUESTS,

  [PAGE_URLS.CLIENT_PORTAL_SETUP_ADMIN_MESSAGES]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_ADMIN_MESSAGES,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ADMIN_MESSAGES_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_ADMIN_MESSAGES,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ADMIN_MESSAGES_CREATE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_ADMIN_MESSAGES,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_ADMIN_MESSAGES_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_ADMIN_MESSAGES,

  [PAGE_URLS.CLIENT_PORTAL_SETUP_CLIENT_USERS]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_USERS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_CLIENT_USERS_VIEW]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_USERS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_CLIENT_USERS_CREATE]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_USERS,
  [PAGE_URLS.CLIENT_PORTAL_SETUP_CLIENT_USERS_EDIT]:
    MODULE_PERMISSIONS.CLIENT_PORTAL_SETUP_CLIENT_USERS,

  //NIS
  [PAGE_URLS.CREATE_NIS_PARTICIPANT]: MODULE_PERMISSIONS.NIS_CREATE,
  [`${PAGE_URLS.VIEW_NIS_PARTICIPANT}/:id`]: MODULE_PERMISSIONS.NIS_VIEW,
  [`${PAGE_URLS.EDIT_NIS_PARTICIPANT}/:id`]: MODULE_PERMISSIONS.NIS_EDIT,
};
